import { HttpService } from '@/Services/http.service';
import { inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { IModificarPdf } from '../interface/modificar.interface';
import { IResponseApiGeneric } from '@/interface/general/IResponseApi';
import { environment } from 'src/environments/environment';
import { EFileType } from '@/shared/components/general/file-preview/file-preview.component';
import { IAccionBoton } from '@/interface/general/IPagination';
import { BotoneraService } from '../../botonera.service';
import { IArchivoAdjunto } from '@/pages/radicacion/radicacion-documento/interface/radicar.interface';
import { TypeMessage } from '@/common/enums/general/TypeMessage';
import { UserInteractiveService } from '@/Services/user-interactive.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  // Servicios
  private httpService = inject(HttpService);
  private botoneraService = inject(BotoneraService);
  private userInteractive = inject(UserInteractiveService);

  // Urls
  private urlGetPages = 'FlujoDoc/ModificarPdf';
  private urlGetBackup = 'FlujoDoc/ObtenerBackupModificarPdf';
  private urlGetPage = 'FlujoDoc/ObtenerPaginaModificarPdf';
  private urlPutUpdate = 'FlujoDoc/ModificarPdf';
  private urlGetPreview = 'FlujoDoc/PrevisualizarModificarPdf';
  private urlPostPublish = 'FlujoDoc/PublicarModificarPdf';
  private urlPostAddFile = 'FlujoDoc/AddFileModificarPdf';

  // Endpoints
  GetPages(IdfdArchivo: number): Observable<IModificarPdf[]> {
    return this.httpService.Get<IResponseApiGeneric<IModificarPdf[]>>(`${this.urlGetPages}?IdfdArchivo=${IdfdArchivo}`)
      .pipe(map((resp) => resp.data));
  }

  PutUpdate(pages: IModificarPdf[]): Observable<boolean> {
    return this.httpService.Put<IResponseApiGeneric<boolean>>({ pages }, `${this.urlPutUpdate}`)
      .pipe(map((resp) => resp.data));
  }

  async GetBackup(IdfdArchivo: number) {
    const urlGetBackup = environment.apiUrl + this.urlGetBackup;
    const url = `${urlGetBackup}?IdfdArchivo=${IdfdArchivo}&RetornarBase64=${true}&RetornarByte=${false}`;
    const accion = { Url1: url, FileType: EFileType.PdfBase64 } as IAccionBoton;  
    return this.botoneraService.verDocumento(accion);
  }  

  async GetPage(Id: number) {
    const urlGetPage = environment.apiUrl + this.urlGetPage;
    const url = `${urlGetPage}?Id=${Id}&RetornarBase64=${true}&RetornarByte=${false}`;
    const accion = { Url1: url, FileType: EFileType.PdfBase64 } as IAccionBoton;  
    return this.botoneraService.verDocumento(accion);
  }

  GetPreview(IdfdArchivo: number) {
    return this.httpService.Get<IResponseApiGeneric<IArchivoAdjunto>>(`${this.urlGetPreview}?IdfdArchivo=${IdfdArchivo}&RetornarBase64=${true}&RetornarByte=${false}`)
      .pipe(map(async (resp) => { 
        const data = resp.data 
        const accion = { FileBase64: data.fileBase64, FileType: EFileType.PdfBase64 } as IAccionBoton;
        await this.botoneraService.verDocumento(accion);
      }));
  }

  PostPublish(IdfdArchivo: number, Descripcion: string, RetornarBase64 = true, RetornarByte = false) {
    return this.httpService.Post<IResponseApiGeneric<IArchivoAdjunto>>({ IdfdArchivo, Descripcion, RetornarBase64, RetornarByte }, this.urlPostPublish)
      .pipe(
        tap((resp) => this._mensaje(resp.mensaje)),
        map(async (resp) => { 
          const data = resp.data;
          const accion = { FileBase64: data.fileBase64, FileType: EFileType.PdfBase64 } as IAccionBoton;
          return await this.botoneraService.verDocumento(accion);
        }));
  }

  PostAddFile(IdfdArchivo: number, FileBase64: string, FileExtension: string, RetornarBase64 = true, RetornarByte = false) {
    return this.httpService.Post<IResponseApiGeneric<IModificarPdf[]>>({ IdfdArchivo, FileBase64, FileExtension, RetornarBase64, RetornarByte }, this.urlPostAddFile)
      .pipe(tap((resp) => this._mensaje(resp.mensaje)),map((resp) => resp.data));
  }

  private _mensaje(message: string) {
    return this.userInteractive.sendMessage(TypeMessage.SUCCESS, message);
  }
}
